export default __webpack_public_path__ + "static/11-8a2a3577dd772f64de27daa20ef26785.webp";